import { style } from "@vanilla-extract/css";
import { breakpoints } from "../../styles/breakpoints";
import { vars } from "../../styles/theme.css";

export const elementLabelStyles = style({
  margin: 0,
  textAlign: "center",
  lineHeight: 1,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.m,
  "@media": {
    [`screen and (min-width:${breakpoints[2]})`]: {
      fontSize: vars.fontSizes.body.l,
    },
  },
});
